// src/contexts/LanguageContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

// Доступные языки
export const LANGUAGES = {
  kz: { code: 'kz', name: 'ҚАЗ', fullName: 'Қазақша' },
  ru: { code: 'ru', name: 'РУС', fullName: 'Русский' },
  en: { code: 'en', name: 'EN', fullName: 'English' }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  // Получаем сохраненный язык или используем русский по умолчанию
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    return localStorage.getItem('selectedLanguage') || 'ru';
  });

  // Функция смены языка
  const changeLanguage = (languageCode) => {
    if (!LANGUAGES[languageCode]) {
      console.error('Unsupported language:', languageCode);
      return;
    }

    setCurrentLanguage(languageCode);
    localStorage.setItem('selectedLanguage', languageCode);
  };

  // Получение информации о текущем языке
  const getCurrentLanguage = () => {
    return LANGUAGES[currentLanguage] || LANGUAGES.ru;
  };

  // Проверка активного языка
  const isActiveLanguage = (languageCode) => {
    return currentLanguage === languageCode;
  };

  const value = {
    currentLanguage,        // Строка: 'ru', 'kk', 'en'
    languages: LANGUAGES,   // Объект всех доступных языков
    changeLanguage,         // Функция смены языка
    getCurrentLanguage,     // Функция получения объекта текущего языка
    isActiveLanguage       // Функция проверки активного языка
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

// Хук для использования контекста
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;